import { funcFormatCurrency } from 'functions/funcFormatCurrency';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { handleCloseDetail } from 'store/kanbanReducer/kanbanSlice';

const ItemKanbanLeadDetail = ({ className }) => {
	const dispatch = useDispatch();
	const taskDetail = useSelector(state => state.kanban.detailKanban);
	const handleClose = () => {
		dispatch(handleCloseDetail());
	}
	return (
		<>
			<div
				className={`kanban-box-detail h-screen top-0 fixed right-0 overflow-auto fixed bg-white w-360px z-[999] shadow-[0px_4px_15px_rgba(0,0,0,.1)] ${className}`}>
				<div
					className="close-button w-50px h-50px ml-auto text-white bg-primary flex items-center justify-center text-4xl font-light cursor-pointer"
					onClick={handleClose}>
					<em className="fa-regular fa-xmark font-light"></em>
				</div>
				<div className="kanban-detail-content px-25px">
					<h2 className="text-20px font-bold mb-10px">
						{taskDetail.name}
					</h2>
					<table>
						<tbody>
							<tr>
								<td>Acc:</td>
								<td>{taskDetail.account}</td>
							</tr>
							<tr>
								<td>Est. cost:</td>
								<td className="text-primary">
									{funcFormatCurrency(taskDetail.money)}
								</td>
							</tr>
							<tr>
								<td>Ngày bắt đầu:</td>
								<td>12/06/2022</td>
							</tr>
							<tr>
								<td>Ngày đóng:</td>
								<td>30/06/2022</td>
							</tr>
						</tbody>
					</table>
					<div className="line h-1px w-full mt-5 mb-5 bg-[#DDDDDD]"></div>
					<table>
						<tbody>
							<tr>
								<td>Lead code:</td>
								<td>KHO1368</td>
							</tr>
							<tr>
								<td>Lead Status:</td>
								<td className="text-primary">New</td>
							</tr>
							<tr>
								<td>Lead Type:</td>
								<td>Website</td>
							</tr>
							<tr>
								<td>Lead source:</td>
								<td>Website</td>
							</tr>
						</tbody>
					</table>
					<table>
						<tbody>
							<tr>
								<td>Người liên hệ:</td>
								<td>Lê Quang Nguyên</td>
							</tr>
							<tr>
								<td>Email:</td>
								<td>lequangnguyen409@gmail.com</td>
							</tr>
							<tr>
								<td>Position:</td>
								<td>Frontend</td>
							</tr>
							<tr>
								<td>Phone:</td>
								<td>0909277777</td>
							</tr>
							<tr>
								<td>Mobile:</td>
								<td>0999999999</td>
							</tr>
							<tr>
								<td>Website:</td>
								<td>quangnguyen.com</td>
							</tr>
							<tr>
								<td>Địa chỉ:</td>
								<td>
									Lorem, ipsum dolor sit amet consectetur
									adipisicing elit. Cupiditate, repellat
									facilis tenetur voluptate eos corporis omnis
									officia ad dicta culpa cum a laboriosam
									similique, nam nesciunt optio perferendis
									voluptatem reprehenderit?
								</td>
							</tr>
						</tbody>
					</table>
					<p>
						<strong>Brief requirement</strong>
					</p>
					<p>
						{taskDetail.note}
					</p>
				</div>
			</div>
		</>
	);
};

export default ItemKanbanLeadDetail;